import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import {
  SafePipe,
  OrderByPipe,
  KeysPipe,
  ObjectLengthPipe,
  FilterPipe,
  SortAlphabeticallyByPipe,
  EscapeHtmlPipe,
  DecodePipe,
  ReversePipe,
  NameFilterPipe,
} from './pipes';
import { IsPermittedDirective } from './directives';
import {
  HELoadingIndicatorComponent,
  HELoadingCardComponent,
  HENativeLoadingIndicatorComponent,
  HEHeaderComponent,
  HEAvatarComponent,
  HEImageComponent,
  LinkedTextComponent,
  OptionsComponent,
  PageHeaderComponent,
  PageComponent,
  AddAttachmentComponent,
  NewImageAttachmentComponent,
  RemovableComponent,
  FileAttachmentComponent,
  ViewFileAttachmentComponent,
  NewFileAttachmentComponent,
} from './components';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { LimitToDirective, ObserveDirective } from '@app/core/directives';
import { SecurePipe } from '@app/core/pipes/secure.pipe';
import { InfiniteScrollComponent } from './components/infinite-scroll/infinite-scroll.component';
import { CdkViewportSizeDirective } from './directives/check-viewport-size.directive';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { LetDirective, PushPipe } from '@ngrx/component';
import { HeaderWithCancelButtonComponent } from './components/header-with-cancel-button/header-with-cancel-button.component';
import { RefresherComponent } from './components/refresher/refresher.component';
import { FocusDirective } from '@app/core/directives/focus/focus.directive';
import { CharacterLimitInputComponent } from './components/character-limit-input/character-limit-input.component';
import { RemoveIfFeatureOffDirective } from './directives/remove-if-feature-off.directive';
import { LocationBadgeComponent } from './components/location-badge/location-badge.component';
import { IsMaskedDirective } from '@app/core/directives/is-masked/is-masked.directive';

@NgModule({
  imports: [
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    IonicModule,
    FontAwesomeModule,
    ScrollingModule,
    LetDirective,
    PushPipe,
    IsMaskedDirective,
  ],
  declarations: [
    SafePipe,
    OrderByPipe,
    KeysPipe,
    ObjectLengthPipe,
    FilterPipe,
    DecodePipe,
    ReversePipe,
    SortAlphabeticallyByPipe,
    IsPermittedDirective,
    EscapeHtmlPipe,
    NameFilterPipe,
    HELoadingIndicatorComponent,
    HELoadingCardComponent,
    HENativeLoadingIndicatorComponent,
    HEHeaderComponent,
    HEAvatarComponent,
    HEImageComponent,
    LimitToDirective,
    ObserveDirective,
    CdkViewportSizeDirective,
    SecurePipe,
    LinkedTextComponent,
    OptionsComponent,
    PageHeaderComponent,
    PageComponent,
    AddAttachmentComponent,
    NewImageAttachmentComponent,
    RemovableComponent,
    FileAttachmentComponent,
    ViewFileAttachmentComponent,
    NewFileAttachmentComponent,
    InfiniteScrollComponent,
    BackButtonComponent,
    HeaderWithCancelButtonComponent,
    RefresherComponent,
    FocusDirective,
    CharacterLimitInputComponent,
    RemoveIfFeatureOffDirective,
    LocationBadgeComponent,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    SafePipe,
    OrderByPipe,
    KeysPipe,
    ObjectLengthPipe,
    FilterPipe,
    DecodePipe,
    ReversePipe,
    SortAlphabeticallyByPipe,
    IsPermittedDirective,
    EscapeHtmlPipe,
    NameFilterPipe,
    HELoadingIndicatorComponent,
    HELoadingCardComponent,
    HENativeLoadingIndicatorComponent,
    HEHeaderComponent,
    HEAvatarComponent,
    HEImageComponent,
    IonicModule,
    FontAwesomeModule,
    ScrollingModule,
    LimitToDirective,
    ObserveDirective,
    CdkViewportSizeDirective,
    SecurePipe,
    LinkedTextComponent,
    OptionsComponent,
    PageHeaderComponent,
    PageComponent,
    AddAttachmentComponent,
    NewImageAttachmentComponent,
    RemovableComponent,
    ViewFileAttachmentComponent,
    NewFileAttachmentComponent,
    InfiniteScrollComponent,
    BackButtonComponent,
    LetDirective,
    PushPipe,
    HeaderWithCancelButtonComponent,
    RefresherComponent,
    FocusDirective,
    CharacterLimitInputComponent,
    RemoveIfFeatureOffDirective,
    LocationBadgeComponent,
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [],
    };
  }
}
